module.exports = __webpack_public_path__ + "static/media/smile.7b784f01.png";